<template>
  <v-container fluid>
    <!-- header -->
    <v-card class="mb-10">
      <v-card-title>
        hommyTest
      </v-card-title>

      <v-card-text>
        LALALAAAAA
      </v-card-text>
    </v-card>

    <!-- body -->
    <v-card>
      <v-row>
        <v-col>



        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
// import ru from 'apexcharts/dist/locales/ru.json'
// import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
// import { axios } from "~/plugins/axios";
// import TimelineChartsQueue from '../partials/TimelineChartsQueue.vue';
// import CaruselButtonV2 from '../partials/CaruselButtonV2.vue';


export default {
  name: 'HommyTest',
  components: {
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapGetters({
    }),

  },

  watch: {

  },

  methods: {
    ...mapActions({
      setSuccess: 'shared/setSuccess',
      setError: 'shared/setError',
      loadTableSlWidget: 'dashboard/loadTableSlWidget',
    }),

  },

  async mounted() {

  },
}
</script>

<style>

</style>